import React, { useEffect, useState, useContext, useCallback } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import CardMobileSection from 'components/sales/tableSection/cardMobileSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { STATUS } from 'constants/statusConstant';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import './siteListing.css';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import FlatFileUpload from 'components/sales/bulkUpload/FlatFileUpload';
import ModalPop from 'components/sales/modal/modal';

const SiteListing = ({
  createInstallationDateChange,
  getSiteListing,
  siteListData,
  getSiteFilters,
  siteFilters,
  getLocationChange,
  locationChange,
  history,
  UploadFlat
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [cardListData, setCardListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [currentInstallationDate, setCurrentInstallationDate] = useState('');
  const [currentCommId, setCurrentCommId] = useState('');
  const [isbulk, setIsbulk] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [isUploaded, setIsuploaded] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [fileUrls, setFileUrls] = useState([]);
  const [isModal, setIsModal] = useState(false);

  const headers = [
    'Site Number',
    'Infra Id',
    'Site Type',
    'Client Name',
    'No.of Gates',
    'Area Name',
    'Assigned To',
    'BA Name',
    'Assigned To Maintenance',
    'Onboard Date',
    'Inst. Start Date',
    'Handover Date',
    (isRoleId === STATUS.CITY_HEAD ||
      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
      'Validate Location',
    'Contract Live Date',
    'Contract Expiry Date',
    'Status',
    'Download Flats',
    'Actions',
  ];
  const cardHeaders = [
    'Site Number',
    'Infra Id',
    'Site Type',
    'Client Name',
    'Area Name',
    'BA Name',
    'Onboard Date',
    'Inst. Start Date',
    'Handover Date',
    (isRoleId === STATUS.CITY_HEAD ||
      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
    'Validate Location',
    'Contract Live Date',
    'Contract Expiry Date',
    'Status',
    'Actions',
  ];

  const sampleData = {
    file_url: fileUrl,
    // 'https://parkqa.kelltontech.net/download_sample/Flat_List_Format.xls',
  };

    async function fetchAttData() {
        try {
          // fetchAttd
            const url = `${Config.attendance.fetchAttd}`;

            const { data } = await axios.get(url);
            // console.log(data.response.data)
            // setData(data?.response?.data);
        } catch {
            console.log('Something went wrong');
        }
    }
  
  const getList = useCallback(async () => {
    setIsLoading(true);
    const getcontractFilter = await JSON.parse(
      localStorage.getItem("installationContractList") &&
        localStorage.getItem("installationContractList")
    );
    setIsLoading(true);
    if(getcontractFilter){
      await getSiteListing(getcontractFilter);
    }else{
      await getSiteListing();
    }
    // await getSiteListing(null, currentPage);
    setIsLoading(false);

  }, [getSiteListing, currentPage]);

  useEffect(() => {
    if (getSiteListing !== null) getList();
  }, [getSiteListing, getList]);

  useEffect(() => {
    fetchAttData();
    const installationCont = JSON.parse(
      localStorage.getItem("installationCont") &&
        localStorage.getItem("installationCont")
    );
    if(installationCont){
      localStorage.setItem("installationContractList", JSON.stringify(""));
      localStorage.setItem("installationCont", 0);
    }
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setIsRoleId(roles[0].pivot.role_id);
      })();
    }, 0);
  }, []);

  // useEffect(() => {
  //   if (getSiteListing !== null)
  //     (async () => {
  //       const getcontractFilter = await JSON.parse(
  //         localStorage.getItem("installationContractList") &&
  //           localStorage.getItem("installationContractList")
  //       );
  //       setIsLoading(true);
  //       if(getcontractFilter){
  //         await getSiteListing(getcontractFilter);
  //       }else{
  //         await getSiteListing();
  //       }

  //     })();
  // }, [getSiteListing]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  const handleUpdateInstallationDate = (installationDate, commId) => {
    setCurrentInstallationDate(installationDate);
    setCurrentCommId(commId);
    setShowModal(true);
  };

  useEffect(() => {
    // console.log(siteListData);
    // const actions1 =
    //   isRoleId === 9
    //     ? [
    //         { name: 'View Details', link: '/dashboard/lead-details' },
    //         { name: 'Site Log', link: '/dashboard/site-log' },
    //         // { name: 'Set Target Date', link: '/dashboard/set-target-date' },
    //         // { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
    //         // { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
    //       ]
    //     : [
    //         { name: 'View Details', link: '/dashboard/lead-details' },
    //         { name: 'Site Log', link: '/dashboard/site-log' },
    //         { name: 'Set Target Date', link: '/dashboard/set-target-date' },
    //         { name: 'Change Assignee', link: '/dashboard/site-assignee' },
    //         { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
    //         { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
    //       ];
    // const actions2 =
    //   isRoleId === 9
    //     ? [
    //         { name: 'View Details', link: '/dashboard/lead-details' },
    //         { name: 'Site Log', link: '/dashboard/site-log' },
    //         // { name: 'Site Stages', link: '/dashboard/site-stage' },
    //         // { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
    //         // { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
    //       ]
    //     : [
    //         { name: 'View Details', link: '/dashboard/lead-details' },
    //         { name: 'Site Log', link: '/dashboard/site-log' },
    //         { name: 'Site Stages', link: '/dashboard/site-stage' },
    //         { name: 'Change Assignee', link: '/dashboard/site-assignee' },
    //         { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
    //         { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
    //       ];

    const tableData = [
      'site_id',
      'site_no',
      'infra_project_id',
      'lead_id',
      'site_type',
      'client_name',
      'gates',
      'area_name',
      'assigned_to',
      'ba_name',
      'assigned_to_maintenance',
      'created_at',
      'installation_start_date',
      'handover_date',
      (isRoleId === STATUS.CITY_HEAD ||
        isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
        'is_location_validate',
        'live_date',
        'expiry_date',
      'status',
      'download_flats',
        'dismantle_mrf_id',
        'is_jms_enabled',
        'jms_id'
    ];
    const cardTableData = [
      'site_id',
      'site_no',
      'infra_project_id',
      'lead_id',
      'site_type',
      'client_name',
      'area_name',
      'ba_name',
      'created_at',
      'installation_start_date',
      'handover_date',
      (isRoleId === STATUS.CITY_HEAD ||
        isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) &&
        'is_location_validate',
      'live_date',
      'expiry_date',
      'status',
      'dismantle_mrf_id',
      'is_jms_enabled',
      'jms_id'
    ];
    // console.log(siteListData);
    if (siteListData && siteListData.resultSets) {
      const cardData = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...cardTableData.map((key) => ({[key]: element[key]} 
          )),
          {
            Action:
            element.target_date_settled === 1
              ? element.status === 'In Maintenance'
                ? [
                    { name: 'View Details', link: '/dashboard/lead-details' },
                    { name: 'Site Stages', link: '/dashboard/site-stage' },
                    { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                    {
                      name: 'Schedule Meeting',
                      link: '/dashboard/meeting-history',
                    },
                    {
                      name: 'Vendor Allocation',
                      link: '/dashboard/vendor-allocation',
                    },
                      {
                        name: 'Site Repository',
                        link: '/dashboard/site-repository',
                      },
                      { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                      {
                        name:'Upload Flat File',
                        link: '',
                      }

                  ]
                : (element.status === 'Live')
                ?
                (element.is_location_validate === 0) ?
                  [
                    { name: 'View Details', link: '/dashboard/lead-details' },
                    { name: 'Site Log', link: '/dashboard/site-log' },
                    { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                      { name: 'Site Stages', link: '/dashboard/site-stage' },
                      { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                      { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
                    {
                      name: 'Site Repository',
                      link: '/dashboard/site-repository',
                    },
                    { name: 'Return Tag', link: '/dashboard/return-tag' },
                    { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                    { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                    // { name: 'Asset Mapping 1', link: '/dashboard/new-site-asset-mapping' },
                    {
                      name:'Upload Flat File',
                      link: '',
                    }
                    
                  ]:
                  [
                    { name: 'View Details', link: '/dashboard/lead-details' },
                    { name: 'Site Log', link: '/dashboard/site-log' },
                    { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                    { name: 'Site Stages', link: '/dashboard/site-stage' },
                    {
                      name: 'Site Repository',
                      link: '/dashboard/site-repository',
                    },
                    { name: 'Return Tag', link: '/dashboard/return-tag' },
                    { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                    { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                    // { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                    {
                      name:'Upload Flat File',
                      link: '',
                    }
                  ]
                : [
                    { name: 'View Details', link: '/dashboard/lead-details' },
                    { name: 'Site Log', link: '/dashboard/site-log' },
                    { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                    { name: 'Site Stages', link: '/dashboard/site-stage' },
                    { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                    { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                    { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
                    { name: 'Return Tag', link: '/dashboard/return-tag' },
                          {
                            name: 'Site Repository',
                            link: '/dashboard/site-repository',
                          },
                    { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                    { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                    {
                      name:'Upload Flat File',
                      link: '',
                    }

                  ]
              // : (isRoleId === 9)
              // ? (element.is_location_validate === 0) ?
              // [
              //   { name: 'View Details', link: '/dashboard/lead-details' },
              //   { name: 'Site Log', link: '/dashboard/site-log' },
              //     { name: 'Site Stages', link: '/dashboard/site-stage' },
              //     { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
              //     { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
              //   {
              //     name: 'Site Repository',
              //     link: '/dashboard/site-repository',
              //   },
              //   { name: 'Project Configuration', link: '/dashboard/project-configuration' },
              //   { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
              // ]:
              // [
              //   { name: 'View Details', link: '/dashboard/lead-details' },
              //   { name: 'Site Log', link: '/dashboard/site-log' },
              //   {
              //     name: 'Site Repository',
              //     link: '/dashboard/site-repository',
              //   },
              //   { name: 'Project Configuration', link: '/dashboard/project-configuration' },
              //   { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
              // ]
              : [
                  { name: 'View Details', link: '/dashboard/lead-details' },
                  { name: 'Site Log', link: '/dashboard/site-log' },
                  { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                  { name: 'Set Target Date', link: '/dashboard/set-target-date' },
                  { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                  { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                  { name: 'Return Tag', link: '/dashboard/return-tag' },
                  { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
                      {
                        name: 'Site Repository',
                        link: '/dashboard/site-repository',
                      },
                  { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                  {
                    name:'Upload Flat File',
                    link: '',
                  }

                ],
          }
        )
      );
      if (cardData) {
        const newCardData = cardData.map(function (obj) {

          if(obj.status === 'Dismantled' || obj.status === "Live" || obj.status === "Dismantle Pending"){
            if(obj?.dismantle_mrf_id){
              obj.Action.push({ name: 'View Dismantle MRF', link: `/dashboard/dismantle-mrf-view`})
            } else if((obj.status === "Live" || obj.status === "Dismantle Pending" || obj.status === "Dismantled") && (parseInt(isRoleId) === 9 || parseInt(isRoleId) === 12)){
              // console.log(obj.status)
              obj.Action.push({ name: 'Dismantle MRF', link: `/dashboard/dismantle-mrf`})
            }
          }
          if(obj.is_jms_enabled){
            let jmsLink = `/dashboard/submit-jms/${obj.site_id}/${obj.lead_id}`;
            if (obj.jms_id !== "" && obj.jms_id !== null && obj.jms_id !== undefined) jmsLink += `/${obj.jms_id}`;
            obj.Action.push({ name: 'Submit JMS', link: jmsLink });
          }
          delete obj?.dismantle_mrf_id
          delete obj?.is_jms_enabled
          delete obj?.jms_id
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newCardData && setCardListData(newCardData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }

    if (siteListData && siteListData.resultSets) {
      const data = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ((key === 'download_flats' && element.flat_file_status == 1) ? 
          {[key]: 'Yes'} : {[key]: element[key]} )),
          {
            Action:
              element.target_date_settled === 1
                ? element.status === 'In Maintenance'
                  ? [
                      { name: 'View Details', link: '/dashboard/lead-details' },
                      { name: 'Site Stages', link: '/dashboard/site-stage' },
                      { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                      {
                        name: 'Schedule Meeting',
                        link: '/dashboard/meeting-history',
                      },
                      {
                        name: 'Vendor Allocation',
                        link: '/dashboard/vendor-allocation/2',
                      },
                        {
                          name: 'Site Repository',
                          link: '/dashboard/site-repository',
                        },
                        { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                        // { name: 'Site Consumables', link: `/dashboard/site-consumes/${element.comm_id}` },
                        {
                          name:'Upload Flat File',
                          link: '',
                        }
                    ]
                  : (element.status === 'Live')
                  ?
                  (element.is_location_validate === 0) ?
                    [
                      { name: 'View Details', link: '/dashboard/lead-details' },
                      { name: 'Site Log', link: '/dashboard/site-log' },
                      { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                        { name: 'Site Stages', link: '/dashboard/site-stage' },
                        { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                        // { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation/3' },
                        { name: 'Additional Service PR', link: '/dashboard/vendor-allocation/4' },
                      {
                        name: 'Site Repository',
                        link: '/dashboard/site-repository',
                      },
                      { name: 'Return Tag', link: '/dashboard/return-tag' },
                      { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                      { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                      // { name: 'Asset Mapping 1', link: '/dashboard/new-site-asset-mapping' },
                      // { name: 'Site Consumables', link: `/dashboard/site-consumes/${element.comm_id}` },
                      {
                        name:'Upload Flat File',
                        link: '',
                      }
                    ]:
                    [
                      { name: 'View Details', link: '/dashboard/lead-details' },
                      { name: 'Site Log', link: '/dashboard/site-log' },
                      { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                      { name: 'Site Stages', link: '/dashboard/site-stage' },
                      {
                        name: 'Site Repository',
                        link: '/dashboard/site-repository',
                      },
                      { name: 'Return Tag', link: '/dashboard/return-tag' },
                      { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                      { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                      // { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                      // { name: 'Site Consumables', link: `/dashboard/site-consumes/${element.comm_id}` },
                      {
                        name:'Upload Flat File',
                        link: '',
                      }
                    ]
                  : 
                  (isRoleId === 9) ?
                    [
                      { name: 'View Details', link: '/dashboard/lead-details' },
                      { name: 'Site Log', link: '/dashboard/site-log' },
                      { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                      { name: 'Site Stages', link: '/dashboard/site-stage' },
                      { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                      { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                      { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation/1' },
                      { name: 'Return Tag', link: '/dashboard/return-tag' },
                            {
                              name: 'Site Repository',
                              link: '/dashboard/site-repository',
                            },
                      { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                      { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                      // { name: 'Site Consumables', link: `/dashboard/site-consumes/${element.comm_id}` },
                      {
                        name:'Upload Flat File',
                        link: '',
                      }
                    ]
                  :
                    [
                        { name: 'View Details', link: '/dashboard/lead-details' },
                        { name: 'Site Log', link: '/dashboard/site-log' },
                        { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                        { name: 'Site Stages', link: '/dashboard/site-stage' },
                        { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                        { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                        { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation/1' },
                        { name: 'Return Tag', link: '/dashboard/return-tag' },
                              {
                                name: 'Site Repository',
                                link: '/dashboard/site-repository',
                              },
                        { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                        { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                        { name: 'Postpone Installation Date', link: `/dashboard/raise-update-installation-date-request/${element.comm_id}` },
                        { name: 'Request Listing', link: `installation-request-listing/${element.comm_id}`},
                        // { name: 'Update Installation Date', link: `/dashboard/raise-update-installation-date-request/${element.comm_id}` },
                        // { name: 'Site Consumables', link: `/dashboard/site-consumes/${element.comm_id}` },
                        {
                          name:'Upload Flat File',
                          link: '',
                        }
                      ]
                // : (isRoleId === 9)
                // ? (element.is_location_validate === 0) ?
                // [
                //   { name: 'View Details', link: '/dashboard/lead-details' },
                //   { name: 'Site Log', link: '/dashboard/site-log' },
                //     { name: 'Site Stages', link: '/dashboard/site-stage' },
                //     { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                //     { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation' },
                //   {
                //     name: 'Site Repository',
                //     link: '/dashboard/site-repository',
                //   },
                //   { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                //   { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                // ]:
                // [
                //   { name: 'View Details', link: '/dashboard/lead-details' },
                //   { name: 'Site Log', link: '/dashboard/site-log' },
                //   {
                //     name: 'Site Repository',
                //     link: '/dashboard/site-repository',
                //   },
                //   { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                //   { name: 'Asset Mapping', link: '/dashboard/new-site-asset-mapping' },
                // ]
                : [
                    { name: 'View Details', link: '/dashboard/lead-details' },
                    { name: 'Site Log', link: '/dashboard/site-log' },
                    { name: 'View Task Details', link: '/dashboard/view-tasks-info' },
                    { name: 'Set Target Date', link: '/dashboard/set-target-date' },
                    { name: 'Change Assignee', link: '/dashboard/site-assignee' },
                    { name: 'Schedule Meeting', link: '/dashboard/meeting-history' },
                    { name: 'Return Tag', link: '/dashboard/return-tag' },
                    { name: 'Vendor Allocation', link: '/dashboard/vendor-allocation/1' },
                    { name: 'Additional Service PR', link: '/dashboard/vendor-allocation/4' },
                        {
                          name: 'Site Repository',
                          link: '/dashboard/site-repository',
                        },
                    { name: 'Project Configuration', link: '/dashboard/project-configuration' },
                    // { name: 'Site Consumables', link: `/dashboard/site-consumes/${element.comm_id}` },
                    {
                      name:'Upload Flat File',
                      link: '',
                    }
                  ],
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          if((obj.status === 'Dismantled' || obj.status === "Live" || obj.status === "Dismantle Pending")){
            if(obj?.dismantle_mrf_id){
              obj.Action.push({ name: 'View Dismantle MRF', link: `/dashboard/dismantle-mrf-view`})
            } else if((obj.status === "Live" || obj.status === "Dismantle Pending" || obj.status === "Dismantled") && (parseInt(isRoleId) === 9 || parseInt(isRoleId) === 12)){
              obj.Action.push({ name: 'Dismantle MRF', link: `/dashboard/dismantle-mrf`})
            }
          }
          if(obj.is_jms_enabled){
            let jmsLink = `/dashboard/submit-jms/${obj.site_id}/${obj.lead_id}`;
            if (obj.jms_id !== "" && obj.jms_id !== null && obj.jms_id !== undefined) jmsLink += `/${obj.jms_id}`;
            obj.Action.push({ name: 'Submit JMS', link: jmsLink });
          }
          delete obj?.dismantle_mrf_id
          delete obj?.is_jms_enabled
          delete obj?.jms_id
          obj['manage_id'] = obj['lead_id'];
          delete obj['lead_id'];
          obj['id'] = obj['site_id'];
          delete obj['site_id'];
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData, isRoleId]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const redirectToBulkAssignment = () => {
    history.push(`${baseUrl}/bulk-assignment?type=installationContractList`);
  }

  const applyFilter = async (filterData) => {
    localStorage.setItem("installationContractList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getSiteListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
        <>
          {isRoleId !== 9 &&
              <Button
                  onClick={redirectToBulkAssignment}
                  className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
              >
                <b className="site_filters" style={{width:"max-content"}}>
                  {localization.bulkAssignment}
                </b>
              </Button>
          }
      <Button
        onClick={filterToggle}
        className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
      >
        <img src={Images?.Filter} alt="" />
        <b className="site_filters" style={{width:"max-content"}}>
        {localization.showFilters}
        </b>
      </Button>
        </>
    );
  };

  const onPageChange = async (val) => {
  
    let filter = JSON.parse(localStorage.getItem("installationContractList") && localStorage.getItem("installationContractList"));
    setIsLoading(true);
    await getSiteListing(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const updateLocation = (val) => {
    const isLocation = val.check === false ? 0 : 1;
    getLocationChange(val.id, isLocation);
  };

  useEffect(() => {
    (async () => {
      if (locationChange.status) {
        setIsLoading(true);
        await getSiteListing();
        setIsLoading(false);
      }
    })();
  }, [locationChange]);

  

  // const handleSaveNewDate = async (newInstallationDate, remarks) => {
  //   try {
  //     // Call your API here to update installation date
  //     const success = await createInstallationDateChange({
  //       comm_id: currentCommId,
  //       new_installation_date: newInstallationDate,
  //       remarks
  //     });
  
  //     if (success) {
  //       setShowModal(false); // Close modal on successful update
  //     } else {
  //       console.error('Failed to update installation date.');
  //       // Handle error or notify user accordingly
  //     }
  //   } catch (error) {
  //     console.error('Failed to update installation date:', error);
  //     // Handle error or notify user accordingly
  //   }
  // };

  const handlebulkSubmit = async () => {
    if (bulkFile !== null) {
      const res = await UploadFlat({
        base_64_file: `${bulkFile}`,
        site_id: isbulk,
      });
      if (res) {
        setIsuploaded(true);
      } else {
        setIsuploaded(false);
      }
    }
  };

  const handleFileChange = (val) => setBulkFile(val);

  const handleDownloadFlatFiles = async (siteNo) => {
    if(siteNo) {
      const url = `${Config.brandActivation.getFlatFiles}?site_no=${siteNo}`;
      const res  = await axios.get(url);
      //console.log(JSON.stringify(res));
      if(res && res.data.response) {
          setIsLoading(true);
          setFileUrls(res?.data?.response.data);
          setIsModal(true);
          setIsLoading(false);
      }
    } else {
      return false;
    }
  }

  const handleModalHide = () => {
    setIsModal(false);
  };

  return (
    <Layout
      title={localization.siteList}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      {window.screen.width < 1000?
      <CardMobileSection
        data={cardListData}
        isId={false}
        isMngId={false}
        headers={cardHeaders}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.resultSets}
        srNo={siteListData?.from}
      />
      :
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.resultSets}
        srNo={siteListData?.from}
        setIsbulk={setIsbulk}
        setFileUrl={setFileUrl}
        handleDownloadFlatFiles={handleDownloadFlatFiles}
      />
      }
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters?.site_types ? siteFilters : null}
        siteFilters
      />
      <FlatFileUpload
        sampleData={sampleData && sampleData}
        handleModalHide={() => {
          setIsbulk(false);
          setIsuploaded(false);
        }}
        handlebulkSubmit={handlebulkSubmit}
        isbulk={isbulk}
        getList={getList}
        handleFileChange={handleFileChange}
        isUploaded={isUploaded}
        redirectUrl={`/site-listing`}
        redirectName={localization.siteListingView}
      />
      <ModalPop
            title={localization.downloadFlats}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
          >
          <div className="row">
            {fileUrls && fileUrls?.length > 0 ? (
              <>
              {fileUrls.map((url,i) => {
                return (
                  <div className="col-md-3" key={i}>
                   <a className="btn btn-primary w-auto ml-2" href={url} download>
                    {`Download File ` + (i+1)}
                   </a>
                  </div>
                )
              }
              )}
              </>
           ):null}
          </div>
      </ModalPop>
      
    </Layout>
  );
};

export default SiteListing;
